import { OrganizationService } from 'src/app/common/services/organization/organization.service';
import { Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { AddTaxSetupComponent } from './add-tax-setup/add-tax-setup.component';

@Component({
  selector: 'tags-formly-field',
  template: `
    <p>Select taxes to apply</p>
    <p-multiSelect
      [options]="organizationTaxes"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      optionLabel="name"
      optionValue="value"
      display="chip"
      defaultLabel="Select taxes to apply"
      appendTo="body"
      [loading]="isLoading"
    >
      <ng-template pTemplate="footer">
        <p class="p-2 bg-primary" (click)="addNewTax()">
          <i class="pi pi-plus mr-2"></i>
          Add new
        </p>
      </ng-template>
    </p-multiSelect>
  `,
  providers: [DialogService]
})
export class ItemTaxesFormlyField extends FieldType implements OnInit {
  subscription = new Subscription();
  organizationTaxes: any[] = [];

  ref: DynamicDialogRef | undefined;

  isLoading = false;

  constructor(
    private organizationService: OrganizationService,
    private dialogService: DialogService
  ) {
    super();
  }
  ngOnInit(): void {
    this.getOrganizationTaxes();
  }

  getOrganizationTaxes(): void {
    this.isLoading = true;
    this.subscription.add(
      this.organizationService.getOrganizationTaxes().subscribe({
        next: (res) => {
          this.organizationTaxes = res.result.map((x) => ({
            name: x.name,
            value: x._id
          }));
          this.isLoading = false;
        }
      })
    );
  }

  addNewTax(): void {
    const ref = this.dialogService.open(AddTaxSetupComponent, {
      header: 'Add tax type',
      width: '50%',
      baseZIndex: 10000,
      data: { selectedTax: '' }
    });

    ref.onClose.subscribe((addedItem) => {
      if (addedItem) {
        this.getOrganizationTaxes();

        const selectedValues = this.formControl.value || [];
        if (!selectedValues.includes(addedItem._id)) {
          this.formControl.setValue([...selectedValues, addedItem._id]);
        }

        ref.close();
      }
    });
  }
}
